module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', _vm._b({
    attrs: {
      "dark": _vm.dark,
      "flat": ""
    }
  }, 'v-card', _vm.attrs, false), [_c('v-card-title', {
    staticClass: "pb-2 overline"
  }, [(_vm.withIcon) ? _c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("filter_list")]) : _vm._e(), _vm._v(" "), (_vm.initialRelationship && _vm.initialRelationship.client) ? _c('span', [_vm._v("\n      " + _vm._s(_vm.initialRelationship.client.first_name) + "\n      " + _vm._s(_vm.initialRelationship.client.last_name) + "\n    ")]) : _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.withClose) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1) : _vm._e(), _vm._v(" "), (_vm.numResults) ? _c('v-chip', {
    staticClass: "mr-0 v-chip--x-small",
    attrs: {
      "color": "primary",
      "outline": ""
    }
  }, [_vm._v(_vm._s(_vm.numResults) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.withThemeToggle) ? [(_vm.dark) ? _c('v-icon', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.dark = false
      }
    }
  }, [_vm._v("light_mode")]) : _c('v-icon', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.dark = true
      }
    }
  }, [_vm._v("dark_mode")])] : _vm._e()], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dense": "",
      "subheader": ""
    }
  }, [_c('v-subheader', {
    staticClass: "py-0 overline"
  }, [_vm._v("\n      Choose a date range\n      "), _c('v-spacer'), _vm._v(" "), (!_vm.requireDaterange) ? [(_vm.disableDate) ? _c('v-chip', {
    staticClass: "mr-0 v-chip--x-small",
    attrs: {
      "icon": "",
      "small": "",
      "outline": ""
    },
    on: {
      "click": function($event) {
        _vm.disableDate = false
      }
    }
  }, [_vm._v("\n          Apply\n          "), _c('v-icon', {
    attrs: {
      "right": "",
      "small": ""
    }
  }, [_vm._v("timer")])], 1) : _c('v-chip', {
    staticClass: "mr-0 v-chip--x-small",
    attrs: {
      "icon": "",
      "small": "",
      "outline": ""
    },
    on: {
      "click": function($event) {
        _vm.disableDate = true
      }
    }
  }, [_vm._v("\n          Clear\n          "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("timer_off")])], 1)] : _vm._e()], 2), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "disabled": _vm.disableDate
    },
    on: {
      "click": function($event) {
        _vm.datepickervisible = true
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("event")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n          " + _vm._s(_vm.dateformat(_vm.dateRange.from)) + " - " + _vm._s(_vm.dateformat(_vm.dateRange.to)) + "\n        ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n          Click to change dates\n        ")])], 1)], 1)], 1), _vm._v(" "), (_vm.datepickervisible) ? _c('date-range-picker', {
    staticClass: "mt-0 pt-0",
    attrs: {
      "with-ok": "",
      "with-close": "",
      "transition": "scroll-y-transition"
    },
    on: {
      "close": function($event) {
        _vm.datepickervisible = false
      }
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-4 my-2"
  }), _vm._v(" "), _vm._t("relationship-picker", function() {
    return [(_vm.dateRange.from && !_vm.initialRelationship) ? _c('relationship-picker', {
      staticClass: "mx-3",
      attrs: {
        "with-quick-pick": "",
        "multiple": _vm.multipleRelationships,
        "practitioner-id": _vm.practitionerId,
        "statuses": _vm.relationshipStatuses,
        "from-date": _vm.dateRange.from,
        "to-date": _vm.dateRange.to,
        "touch": _vm.touch
      },
      on: {
        "count": _vm.setCount
      },
      model: {
        value: (_vm.selectedRelationships),
        callback: function($$v) {
          _vm.selectedRelationships = $$v
        },
        expression: "selectedRelationships"
      }
    }) : _vm._e()]
  }), _vm._v(" "), (!_vm.mini && _vm.dateRange.from && _vm.dateRange.to) ? [(_vm.facets && _vm.facets.practitioner) ? [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("\n        Practitioner\n        "), _c('v-spacer'), _vm._v(" "), (_vm.selectedPractitioners > 0) ? _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": ""
    },
    on: {
      "click": function($event) {
        _vm.selectedPractitioners = []
      }
    }
  }, [_vm._v("clear")]) : _vm._e()], 1), _vm._v(" "), _vm._l((_vm.getColleagues), function(data, pk) {
    return [_c('v-checkbox', {
      key: pk,
      staticClass: "pa-0 ma-0 ml-2",
      attrs: {
        "hide-details": "",
        "dense": "",
        "value": pk,
        "color": data.color,
        "label": _vm.getPractitionerLabel(data, _vm.facets.practitioner)
      },
      model: {
        value: (_vm.selectedPractitioners),
        callback: function($$v) {
          _vm.selectedPractitioners = $$v
        },
        expression: "selectedPractitioners"
      }
    })]
  })] : _vm._e(), _vm._v(" "), _c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Status\n      "), _c('v-spacer'), _vm._v(" "), (_vm.selectedStatuses > 0) ? _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": ""
    },
    on: {
      "click": function($event) {
        _vm.selectedStatuses = []
      }
    }
  }, [_vm._v("clear")]) : _vm._e()], 1), _vm._v(" "), _vm._l((_vm.statuses), function(data, code) {
    return [_c('v-checkbox', {
      key: code,
      staticClass: "pa-0 ma-0 ml-2",
      attrs: {
        "hide-details": "",
        "dense": "",
        "value": code,
        "color": data.theme,
        "label": _vm.getStatusLabel(code, data, _vm.facets.status)
      },
      model: {
        value: (_vm.selectedStatuses),
        callback: function($$v) {
          _vm.selectedStatuses = $$v
        },
        expression: "selectedStatuses"
      }
    })]
  }), _vm._v(" "), (_vm.facets && _vm.facets.space) ? [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Space\n        "), _c('v-spacer'), _vm._v(" "), (_vm.selectedSpaces > 0) ? _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": ""
    },
    on: {
      "click": function($event) {
        _vm.selectedSpaces = []
      }
    }
  }, [_vm._v("clear")]) : _vm._e()], 1), _vm._v(" "), _vm._l((_vm.spaces), function(space) {
    return [_c('v-checkbox', {
      key: space.id,
      staticClass: "pa-0 ma-0 ml-2",
      attrs: {
        "hide-details": "",
        "dense": "",
        "value": space.id,
        "color": space.color,
        "label": _vm.getSpaceLabel(space, _vm.facets.space)
      },
      model: {
        value: (_vm.selectedSpaces),
        callback: function($$v) {
          _vm.selectedSpaces = $$v
        },
        expression: "selectedSpaces"
      }
    })]
  })] : _vm._e(), _vm._v(" "), [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Codes\n        "), _c('v-spacer'), _vm._v(" "), _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": ""
    },
    on: {
      "click": function($event) {
        _vm.hasCodes = null
      }
    }
  }, [_vm._v("clear")])], 1), _vm._v(" "), _c('v-radio-group', {
    staticClass: "pa-0 ma-0 ml-2",
    model: {
      value: (_vm.hasCodes),
      callback: function($$v) {
        _vm.hasCodes = $$v
      },
      expression: "hasCodes"
    }
  }, [_c('v-radio', {
    attrs: {
      "value": "yes",
      "label": "Have ICD-10 codes"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "value": "no",
      "label": "Without ICD-10 codes"
    }
  })], 1)]] : _vm._e(), _vm._v(" "), _vm._t("actions"), _vm._v(" "), [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Results per page")]), _vm._v(" "), _c('v-layout', {
    staticClass: "mb-4"
  }, [_c('v-spacer'), _vm._v(" "), _vm._l((_vm.pageSizes), function(size) {
    return _c('v-flex', {
      key: size
    }, [_c('v-checkbox', {
      key: size,
      staticClass: "pa-0 ma-0",
      attrs: {
        "hide-details": "",
        "dense": "",
        "value": size,
        "label": ("" + (size.toString()))
      },
      model: {
        value: (_vm.selectedPageSize),
        callback: function($$v) {
          _vm.selectedPageSize = $$v
        },
        expression: "selectedPageSize"
      }
    })], 1)
  }), _vm._v(" "), _c('v-spacer')], 2)]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72d4aa22","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/filters/AppointmentFilters.vue
// module id = 1468
// module chunks = 9